export const brush = {
    style: {
        fill: "#B0C8F9",
        fillOpacity: .2,
        stroke: "#B0C8F9",
        lineWidth: 2
    },
    brushMode: "single",
    brushType: "rect",
    brushMoved: !0,
    removeOnClick: !0,
    delayType: "throttle",
    delayTime: 0
};
//# sourceMappingURL=brush.js.map
